import { useEffect, useState } from "react";

import { RenewalPage } from "@/config/app-constant";
import { CONTENT_PATH, MAGNOLIA_PAGES_URL } from "@/constants";
import axiosCMSClient from "@/libs/axios-cms-client";
import { RenewalPageType } from "@/schema/renewal-page/page-content.schema";
import { MagnoliaNode } from "@/types/magnolia-utils";
import { normaliseMagnoliaResponse } from "@/utils/magnolia/magnolia.utils";
import { transformRenewalMTAQuoteCreateModalData } from "@/utils/magnolia/transform.utils";

type MenuItemType = {
  uniqueId: string;
  title: string;
  modalContentOne: string;
  modalCTAButtonLabelOne: string;
  modalCTAButtonLabelTwo: string;
  modalContentTwo?: string;
  modalMiddleContentTitle?: string;
  modalMiddleContentDescription?: string;
};

type ErrorModalContent = {
  errorModalTitle: string;
  errorModalContent: string;
  errorModalCTAButtonLabel: string;
};

type MTAModalData = {
  menuItems: MenuItemType[];
  errorModalContent: ErrorModalContent;
};

export function useFetchMTAModalData() {
  const [data, setData] = useState<MTAModalData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchModalData = async () => {
      const url = `${MAGNOLIA_PAGES_URL}${CONTENT_PATH}/${RenewalPage}`;
      try {
        setLoading(true);
        const response = await axiosCMSClient.get(url);
        const node = response.data as MagnoliaNode;
        const formattedData: RenewalPageType = normaliseMagnoliaResponse(node);
        const pageData = formattedData.renewalPageArea[0];

        const menuItemsObject = transformRenewalMTAQuoteCreateModalData(
          pageData.mtaQuoteCreationModalContent[0]
        );

        if (menuItemsObject) {
          setData({
            menuItems: menuItemsObject.menuItems,
            errorModalContent: {
              errorModalTitle: menuItemsObject.errorModalTitle,
              errorModalContent: menuItemsObject.errorModalContent,
              errorModalCTAButtonLabel:
                menuItemsObject.errorModalCTAButtonLabel,
            },
          });
        }
        setLoading(false);
      } catch (err) {
        const errorMessage =
          err instanceof Error
            ? err.message
            : "Unexpected error fetching modal data";
        // eslint-disable-next-line no-console
        console.error("Error fetching MTA modal data:", err);
        setError(new Error(errorMessage));
        setLoading(false);
      }
    };

    fetchModalData();
  }, []);

  return { data, loading, error };
}
